import React from 'react';
import SocialMediaLinksEnhanced from './SocialMediaLinksEnhanced';
import './SocialMediaDemo.css';

const SocialMediaDemo: React.FC = () => {

  return (
    <div className="social-media-demo-container">
      {/* <div className="social-media-demo-header">
        <h1 className="social-media-demo-title">Social Media Components</h1>
        <p className="social-media-demo-description">
          Choose between two different styles of social media components
        </p>
        
        <div className="social-media-demo-toggle">
          <button 
            className={`toggle-button ${activeVersion === 'basic' ? 'active' : ''}`}
            onClick={() => setActiveVersion('basic')}
          >
            Basic Version
          </button>
          <button 
            className={`toggle-button ${activeVersion === 'enhanced' ? 'active' : ''}`}
            onClick={() => setActiveVersion('enhanced')}
          >
            Enhanced Version
          </button>
        </div>
      </div> */}
      
      {/* <div className="social-media-demo-content">
        {activeVersion === 'basic' ? (
          <div className="social-media-demo-version">
            <SocialMediaLinks />
          </div>
        ) : (
          <div className="social-media-demo-version">
            <SocialMediaLinksEnhanced />
          </div>
        )}
      </div> */}
      <div className="social-media-demo-content">
      <div className="social-media-demo-version">
            <SocialMediaLinksEnhanced />
          </div>
      </div>
    </div>
  );
};

export default SocialMediaDemo;
